import { clientPublic , clientPublicService } from 'helper/axios'

export const getResultOperation = async ({ level_id, token }) => {
  try {
    return await clientPublic
      .get(`company?level=${2}&level_id=${level_id}&limit=99`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const getResultOperationV2 = async ({ level_id, token }) => {
  try {
    return await clientPublicService
      .get(`/core/company?level=${2}&level_id=${level_id}&limit=99`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}
